;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    "aria-hidden": "true",
    className: "google_svg__pbs-google",
    viewBox: "0 0 46 46"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4285f4",
    fillRule: "evenodd",
    d: "M45 23.5c0-1.6-.1-3.2-.4-4.7H23v8.9h12.4c-.5 2.9-2.1 5.3-4.6 6.9v5.8h7.4c4.3-4 6.8-9.9 6.8-16.9",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#34a853",
    fillRule: "evenodd",
    d: "M23 45.9c6.2 0 11.4-2.1 15.2-5.6l-7.4-5.8c-2.1 1.4-4.7 2.2-7.8 2.2-6 0-11-4-12.8-9.5H2.5v5.9C6.3 40.8 14 45.9 23 45.9",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbc05",
    fillRule: "evenodd",
    d: "M10.2 27.3c-.5-1.4-.8-2.8-.8-4.3s.3-3 .7-4.4v-5.9H2.4C.9 15.8 0 19.3 0 23s.9 7.2 2.4 10.3z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ea4335",
    fillRule: "evenodd",
    d: "M23 9.1c3.4 0 6.4 1.2 8.8 3.4L38.4 6c-4-3.7-9.2-6-15.4-6C14 0 6.3 5.2 2.5 12.7l7.7 5.9C12 13.2 17 9.1 23 9.1",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h46v45.9H0z"
  })));
};
export default SvgGoogle;